export let REFRESH_PUSH_SF_GRID_FIELD = undefined
export const NOTIFY_ERROR = 'NOTIFY_ERROR'
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS'

export const WB_LOAD_PREVIEW_CUSTOM_SCRIPT = 'WB_LOAD_PREVIEW_CUSTOM_SCRIPT'
export const WB_ELEM_INLINE_CHANGE = 'WB_ELEM_INLINE_CHANGE'
export const REFRESH_PREVIEW_MODE = 'REFRESH_PREVIEW_MODE'
export const WB_VIEW_ITEM_UPDATE_STYLES = 'WB_VIEW_ITEM_UPDATE_STYLES'
export const WB_VIEW_THEME_UPDATE_STYLES = 'WB_VIEW_THEME_UPDATE_STYLES'
export const WB_SET_PARAMS_TO_STATE = 'WB_SET_PARAMS_TO_STATE'
export const WIDGET_VIEW_ITEM_ALIGN_ELEMS = 'WIDGET_VIEW_ITEM_ALIGN_ELEMS'
export const WB_VIEW_ADD_ROOT_PANEL = 'WB_VIEW_ADD_ROOT_PANEL'
export const WB_VIEW_ITEM_ADD_ROOT_GRID = 'WB_VIEW_ITEM_ADD_ROOT_GRID'
export const WB_VIEW_MOVE_GRID = 'WB_VIEW_MOVE_GRID'
export const WB_VIEW_REORDER_GRID = 'WB_VIEW_REORDER_GRID'
export const WB_VIEW_REORDER_ZINDEX = 'WB_VIEW_REORDER_ZINDEX'
export const WB_VIEW_GRID_ELEM_DEL = 'WB_VIEW_GRID_ELEM_DEL'
export const WB_ELEM_AUTO_HEIGHT = 'WB_ELEM_AUTO_HEIGHT'
export const WB_SELECTION_LOCK = 'WB_SELECTION_LOCK'
export const WB_VIEW_ITEM_RENAME_AREA = 'WB_VIEW_ITEM_RENAME_AREA'
export const UPDATE_POWER_TABLE_RECORD = 'UPDATE_POWER_TABLE_RECORD'
export const APPLY_QUICK_UPDATE_TABLE = 'APPLY_QUICK_UPDATE_TABLE'
export const START_QUICK_UPDATE_TABLE = 'START_QUICK_UPDATE_TABLE'

export const GET_AUTH_REQUEST = 'GET_AUTH_REQUEST'
export const GET_AUTH_REQUEST_ERROR = 'GET_AUTH_REQUEST_ERROR'

export const GET_DOCUMENTS_LIST = 'GET_DOCUMENTS_LIST'

export const DOCUMENT_REQUEST_INVALID_LICENSE = 'DOCUMENT_REQUEST_INVALID_LICENSE'
export const UPDATE_DOCUMENT_REQUEST_ERROR = 'UPDATE_DOCUMENT_REQUEST_ERROR'

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'

export const SET_USER = 'SET_USER'

export const GET_DOCUMENT_SUBMISSIONS_REQUEST = 'GET_DOCUMENT_SUBMISSIONS_REQUEST'
export const GET_DOCUMENT_SUBMISSIONS_REQUEST_SUCCESS = 'GET_DOCUMENT_SUBMISSIONS_REQUEST_SUCCESS'
export const GET_DOCUMENT_SUBMISSIONS_REQUEST_ERROR = 'GET_DOCUMENT_SUBMISSIONS_REQUEST_ERROR'

export const CLEAR_SF_ACTIONS_QUERY = 'CLEAR_SF_ACTIONS_QUERY'

export const GET_SALESFORCE_OBJECTS_REQUEST = 'GET_SALESFORCE_OBJECTS'
export const GET_SALESFORCE_OBJECTS_REQUEST_SUCCESS = 'GET_SALESFORCE_OBJECTS_SUCCESS'
export const GET_SALESFORCE_OBJECTS_REQUEST_ERROR = 'GET_SALESFORCE_OBJECTS_ERROR'

export const REFRESH_GET_SALESFORCE_GRID_FIELDS = 'REFRESH_SALESFORCE_GRID_FIELDS_GET'
export const REFRESH_PUSH_SALESFORCE_GRID_FIELDS = 'REFRESH_SALESFORCE_GRID_FIELDS_PUSH'

export const GET_SALESFORCE_OBJECTS_FIELDS_REQUEST = 'GET_SALESFORCE_OBJECTS_FIELDS'
export const GET_SALESFORCE_OBJECTS_FIELDS_REQUEST_SUCCESS = 'GET_SALESFORCE_OBJECTS_FIELDS_SUCCESS'
export const GET_SALESFORCE_OBJECTS_FIELDS_REQUEST_ERROR = 'GET_SALESFORCE_OBJECTS_FIELDS_ERROR'

export const ADD_SF_CONDITION = 'ADD_SF_CONDITION'
export const DELETE_SF_CONDITION = 'DELETE_SF_CONDITION'

export const SET_CONFIRMATION_HASH = 'SET_CONFIRMATION_HASH'
export const SET_SF_SMART_HASH = 'SET_SF_SMART_HASH'

export const ADD_SMART_V_SETTING = 'ADD_SMART_V_SETTING'
export const DELETE_SMART_V_SETTING = 'DELETE_SMART_V_SETTING'

export const ADD_SF_QUERY_CONDITION = 'ADD_SF_QUERY_CONDITION'
export const DELETE_SF_QUERY_CONDITION = 'DELETE_SF_QUERY_CONDITION'

export const SET_VIEW_SIGN_MODE = 'SET_VIEW_SIGN_MODE'

export const PREPARE_ADD_PAGE_COMMENT = 'PREPARE_ADD_PAGE_COMMENT'
export const PREPARE_UPDATE_PAGE_COMMENT = 'PREPARE_UPDATE_PAGE_COMMENT'
export const PREPARE_DELETE_PAGE_COMMENT = 'PREPARE_DELETE_PAGE_COMMENT'
export const PREPARE_MOVE_PAGE_COMMENT = 'PREPARE_MOVE_PAGE_COMMENT'

export const SIGN_ADD_PAGE_COMMENT = 'SIGN_ADD_PAGE_COMMENT'
export const SIGN_UPDATE_PAGE_COMMENT = 'SIGN_UPDATE_PAGE_COMMENT'
export const SIGN_DELETE_PAGE_COMMENT = 'SIGN_DELETE_PAGE_COMMENT'
export const SIGN_MOVE_PAGE_COMMENT = 'SIGN_MOVE_PAGE_COMMENT'

export const SIGN_SYNC_COMMENTS = 'SIGN_SYNC_COMMENTS'
export const SIGN_SYNC_SIGNATURES = 'SIGN_SYNC_SIGNATURES'

export const SIGN_SET_USERS = 'SIGN_SET_USERS'

export const SIGN_GET_PICKLISTS = 'SIGN_GET_PICKLISTS'
export const SIGN_GET_PICKLISTS_SUCCESS = 'SIGN_GET_PICKLISTS_SUCCESS'
export const SIGN_GET_PICKLISTS_ERROR = 'SIGN_GET_PICKLISTS_ERROR'

export const SIGN_DOCUMENT_INIT_PAGES = 'SIGN_DOCUMENT_INIT_PAGES'

export const SIGN_SHOW_INVALID_FIEDLS = 'SIGN_SHOW_INVALID_FIEDLS'

export const PREPARE_DOCUMENT_INIT_PAGES = 'PREPARE_DOCUMENT_INIT_PAGES'
export const PREPARE_DOCUMENT_DEL_PAGE = 'PREPARE_DOCUMENT_DEL_PAGE'
export const PREPARE_DOCUMENT_COPY_PAGE = 'PREPARE_DOCUMENT_COPY_PAGE'
export const PREPARE_DOCUMENT_MOVE_PAGE = 'PREPARE_DOCUMENT_MOVE_PAGE'
export const PREPARE_DOCUMENT_ADD_PAGE = 'PREPARE_DOCUMENT_ADD_PAGE'

export const PREPARE_GET_OAUTH_LINKS = 'PREPARE_GET_OAUTH_LINKS'
export const PREPARE_GET_OAUTH_ALIVE_STATUS = 'PREPARE_GET_OAUTH_ALIVE_STATUS'
export const PREPARE_GET_OAUTH_STATUS = 'PREPARE_GET_OAUTH_STATUS'
export const PREPARE_SF_GET_OAUTH_STATUS = 'PREPARE_SF_GET_OAUTH_STATUS'
export const PREPARE_GET_STRIP_TEMPLATES = 'PREPARE_GET_STRIP_TEMPLATES'

export const PREPARE_GET_LANG = 'PREPARE_GET_LANG'

export const PREPARE_FIELD_CUT = 'PREPARE_FIELD_CUT'
export const PREPARE_FIELD_COPY = 'PREPARE_FIELD_COPY'
export const PREPARE_FIELD_PASTE = 'PREPARE_FIELD_PASTE'
export const PREPARE_FIELD_DUB = 'PREPARE_FIELD_DUB'

export const PREPARE_SELECTED_ALIGN_LEFT = 'PREPARE_SELECTED_ALIGN_LEFT'
export const PREPARE_SELECTED_ALIGN_CENTER = 'PREPARE_SELECTED_ALIGN_CENTER'
export const PREPARE_SELECTED_ALIGN_RIGHT = 'PREPARE_SELECTED_ALIGN_RIGHT'
export const PREPARE_SELECTED_ALIGN_TOP = 'PREPARE_SELECTED_ALIGN_TOP'
export const PREPARE_SELECTED_ALIGN_MIDDLE = 'PREPARE_SELECTED_ALIGN_MIDDLE'
export const PREPARE_SELECTED_ALIGN_BOTTOM = 'PREPARE_SELECTED_ALIGN_BOTTOM'

export const PREPARE_UPDATE_SELECTED_FIELDS = 'PREPARE_UPDATE_SELECTED_FIELDS'

export const PREPARE_CLEAN_UP_DOCUMENT_MAPPING = 'PREPARE_CLEAN_UP_DOCUMENT_MAPPING'

///portal
export const CLEAR_PORTAL_CHANGED = 'CLEAR_PORTAL_CHANGED'
export const PORTAL_CREATE = 'PORTAL_CREATE'
export const PORTAL_SET_DATA = 'PORTAL_SET_DATA'
export const PORTAL_SERVER_CREATE = 'PORTAL_SERVER_CREATE'
export const PORTAL_SERVER_CREATE_SUCCESS = 'PORTAL_SERVER_CREATE_SUCCESS'
export const PORTAL_SERVER_CREATE_ERROR = 'PORTAL_SERVER_CREATE_ERROR'

export const PROJECT_SERVER_UPDATE = 'PROJECT_SERVER_UPDATE'
export const PROJECT_SERVER_UPDATE_SUCCESS = 'PROJECT_SERVER_UPDATE_SUCCESS'
export const SHOW_MODAL_ASK_USER_TEXT = 'SHOW_MODAL_ASK_USER_TEXT'

export const PORTAL_SERVER_LOAD_LIST = 'PORTAL_SERVER_LOAD_LIST'
export const PORTAL_SERVER_LOAD_LIST_SUCCESS = 'PORTAL_SERVER_LOAD_LIST_SUCCESS'

export const PORTAL_SERVER_LOAD_PORTAL = 'PORTAL_SERVER_LOAD_PORTAL'
export const PORTAL_SERVER_LOAD_PORTAL_SUCCESS = 'PORTAL_SERVER_LOAD_PORTAL_SUCCESS'
export const PORTAL_SERVER_LOAD_PORTAL_ERROR = 'PORTAL_SERVER_LOAD_PORTAL_ERROR'

export const PORTAL_SET_DEFAULT_PAGE = 'PORTAL_SET_DEFAULT_PAGE'
export const PORTAL_SELECT_WIDGET = 'PORTAL_SELECT_WIDGET'
export const PORTAL_ADD_WIDGET_REF = 'PORTAL_ADD_WIDGET_REF'
export const PORTAL_SET_WIDGET_DATA = 'PORTAL_SET_WIDGET_DATA'
export const PORTAL_SET_WIDGETS_DATA = 'PORTAL_SET_WIDGETS_DATA'
export const PROJECT_UPDATE_PAGES = 'PROJECT_UPDATE_PAGES'
export const PROJECT_PAGE_LOADING_STATUS = 'PROJECT_PAGE_LOADING_STATUS'
export const PORTAL_WIDGETS_DATA_LOADING_STATUS = 'PORTAL_WIDGETS_DATA_LOADING_STATUS'
export const PORTAL_WIDGET_SET_PROPS = 'PORTAL_WIDGET_SET_PROPS'
export const PORTAL_WIDGET_UPDATE_PROPS = 'PORTAL_WIDGET_UPDATE_PROPS'

export const PORTAL_ADD_PAGE = 'PORTAL_ADD_PAGE'
export const PORTAL_REORDER_PAGE = 'PORTAL_REORDER_PAGE'
export const PORTAL_SELECT_PAGE = 'PORTAL_SELECT_PAGE'
export const PORTAL_UPDATE_WIDGETS_DATA = 'PORTAL_UPDATE_WIDGETS_DATA'
export const PROJECT_BUILDER_SELECT_PAGE = 'PROJECT_BUILDER_SELECT_PAGE'
export const PROJECT_SET_PREVIEW_DATA = 'PROJECT_SET_PREVIEW_DATA'
export const PROJECT_DELETE_PAGE = 'PROJECT_DELETE_PAGE'
export const PROJECT_UPDATE_PROPS = 'PROJECT_UPDATE_PROPS'
export const PROJECT_SET_RESET_PAGE_PARAMS = 'PROJECT_SET_RESET_PAGE_PARAMS'
export const PROJECT_SET_IS_DISALLOW_PREVIEW = 'PROJECT_SET_IS_DISALLOW_PREVIEW'
export const PROJECT_SET_PREVIEW_PAGE = 'PROJECT_SET_PREVIEW_PAGE'
export const PROJECT_SET_PREVIEW_PAGE_DATA = 'PROJECT_SET_PREVIEW_PAGE_DATA'
export const PROJECT_TOGGLE_DRAWER = 'PROJECT_TOGGLE_DRAWER'
export const PROJECT_PROCESS_COND_CACHE = 'PROJECT_PROCESS_COND_CACHE'
export const PROJECT_PROCESS_COND_QUE_CACHE = 'PROJECT_PROCESS_COND_QUE_CACHE'
export const PROJECT_APPLY_THEME = 'PROJECT_APPLY_THEME'

export const PORTAL_UPDATE_PROPS = 'PORTAL_UPDATE_PROPS'

export const PORTAL_SF_REPORT_LIST_FETCH = 'PORTAL_SF_REPORT_LIST_FETCH'
export const PORTAL_SF_REPORT_LIST_ERROR = 'PORTAL_SF_REPORT_LIST_ERROR'
export const PORTAL_SF_REPORT_LIST_SUCCESS = 'PORTAL_SF_REPORT_LIST_SUCCESS'

export const PORTAL_SF_REPORT_DATA_FETCH = 'PORTAL_SF_REPORT_DATA_FETCH'
export const PORTAL_SF_REPORT_DATA_ERROR = 'PORTAL_SF_REPORT_DATA_ERROR'
export const PORTAL_SF_REPORT_DATA_SUCCESS = 'PORTAL_SF_REPORT_DATA_SUCCESS'

export const PORTAL_PREVIEW_LOAD_WDIGETS_DATA = 'PORTAL_PREVIEW_LOAD_WDIGETS_DATA'
export const PORTAL_PREVIEW_LOAD_WDIGETS_DATA_ERROR = 'PORTAL_PREVIEW_LOAD_WDIGETS_DATA_ERROR'
export const PORTAL_PREVIEW_LOAD_WDIGETS_DATA_SUCCESS = 'PORTAL_PREVIEW_LOAD_WDIGETS_DATA_SUCCESS'
export const PORTAL_PREVIEW_LOAD_WDIGETS_DATA_LOADED = 'PORTAL_PREVIEW_LOAD_WDIGETS_DATA_LOADED'

export const WIDGET_BUILDER_CREATE = 'WIDGET_BUILDER_CREATE'
export const WIDGET_BUILDER_UPDATE = 'WIDGET_BUILDER_UPDATE'
export const WIDGET_BUILDER_SET_DATA = 'WIDGET_BUILDER_SET_DATA'

export const WB_SRV_CREATE = 'WB_SRV_CREATE'
export const WB_SRV_CREATE_SUCCESS = 'WB_SRV_CREATE_SUCCESS'
export const WB_SRV_CREATE_ERROR = 'WB_SRV_CREATE_ERROR'

export const WB_SRV_UPDATE = 'WB_SRV_UPDATE'
export const WB_SRV_UPDATE_ERROR = 'WB_SRV_UPDATE_ERROR'
export const WB_SRV_UPDATE_SUCCESS = 'WB_SRV_UPDATE_SUCCESS'

export const WB_SRV_LIST = 'WB_SRV_LIST'
export const WB_SRV_LIST_SUCCESS = 'WB_SRV_LIST_SUCCESS'
export const WB_SRV_LIST_ERROR = 'WB_SRV_LIST_ERROR'

export const WB_SRV_GET_BY_ID = 'WB_SRV_GET_BY_ID'
export const WB_SRV_GET_BY_ID_SUCCESS = 'WB_SRV_GET_BY_ID_SUCCESS'
export const WB_SRV_GET_BY_ID_ERROR = 'WB_SRV_GET_BY_ID_ERROR'

export const WIDGET_UPDATE_PARAMS = 'WIDGET_UPDATE_PARAMS'
export const PORTAL_UPDATE_LIB_WIDGET = 'PORTAL_UPDATE_LIB_WIDGET'

export const PORTAL_TOGGLE_NAVBAR = 'PORTAL_TOGGLE_NAVBAR'
export const PORTAL_REMOVE_PAGE = 'PORTAL_REMOVE_PAGE'

export const PORTAL_SET_PAGE_LAYOUT_REF = 'PORTAL_SET_PAGE_LAYOUT_REF'
export const PORTAL_RESET_PAGE_LAYOUT = 'PORTAL_RESET_PAGE_LAYOUT'

export const PORTAL_WIDGET_DELETE = 'PORTAL_WIDGET_DELETE'
export const PORTAL_WIDGET_CUT = 'PORTAL_WIDGET_CUT'
export const PORTAL_WIDGET_COPY = 'PORTAL_WIDGET_COPY'
export const PORTAL_WIDGET_PASTE = 'PORTAL_WIDGET_PASTE'
export const PORTAL_WIDGET_DUPLICATE = 'PORTAL_WIDGET_DUPLICATE'
export const WIDGET_SERVER_LOAD_PORTAL_SUCCESS = 'WIDGET_SERVER_LOAD_PORTAL_SUCCESS'

export const PORTAL_SET_PAGE_LAYOUTS = 'PORTAL_SET_PAGE_LAYOUTS'

export const APPLY_THEME = 'APPLY_THEME'
export const SAVE_THEME = 'SAVE_THEME'

export const POST_MSG_SET_VAL = 'POST_MSG_SET_VAL'
export const WIDGET_SET_FORM_HIDDEN = 'WIDGET_SET_FORM_HIDDEN'
export const PORTAL_SET_FORM_HIDDEN = 'PORTAL_SET_FORM_HIDDEN'
export const WIDGET_VIEW_MODE = 'WIDGET_VIEW_MODE'
export const SET_RECALC_DEVICE_ELEMENT = 'SET_RECALC_DEVICE_ELEMENT'
export const WIDGET_LAYOUT_MODE = 'WIDGET_LAYOUT_MODE'
export const SET_SHOW_ELEMENT_SETTINGS_PANEL = 'SET_SHOW_ELEMENT_SETTINGS_PANEL'
export const WIDGET_VIEW_ITEM_DND_MOVE = 'WIDGET_VIEW_ITEM_DND_MOVE'
export const WIDGET_VIEW_ITEM_DELETE = 'WIDGET_VIEW_ITEM_DELETE'
export const CONFIRM_DELETE_STRIP_AREA = 'CONFIRM_DELETE_STRIP_AREA'
export const WIDGET_VIEW_ITEM_CHANGE_POSITION_ALIGMENT = 'WIDGET_VIEW_ITEM_CHANGE_POSITION_ALIGMENT'
export const WIDGET_VIEW_MULY_POSITION_CHANGED = 'WIDGET_VIEW_MULY_POSITION_CHANGED'
export const WB_VIEW_ITEM_ELEM_CHANGE_STYLE = 'WB_VIEW_ITEM_ELEM_CHANGE_STYLE'
export const WIDGET_VIEW_ITEM_CHANGE_PROP = 'WIDGET_VIEW_ITEM_CHANGE_PROP'
export const WIDGET_VIEW_ITEM_RESIZE = 'WIDGET_VIEW_ITEM_RESIZE'
export const WIDGET_VIEW_ITEM_MULTIPLE_RESIZE = 'WIDGET_VIEW_ITEM_MULTIPLE_RESIZE'
export const WIDGET_VIEW_ITEM_RESIZE_PARENT = 'WIDGET_VIEW_ITEM_RESIZE_PARENT'
export const WIDGET_VIEW_ITEM_RESIZE_ITERATION = 'WIDGET_VIEW_ITEM_RESIZE_ITERATION'
export const WIDGET_VIEW_ITEM_CHANGE_PARENT_PROPS = 'WIDGET_VIEW_ITEM_CHANGE_PARENT_PROPS'
export const PAGE_PROCESS_NEW_ELEM = 'PAGE_PROCESS_NEW_ELEM'
export const WIDGET_VIEW_ITEM_MOVE = 'WIDGET_VIEW_ITEM_MOVE'
export const WIDGET_VIEW_ITEM_ADD_ROW = 'WIDGET_VIEW_ITEM_ADD_ROW'
export const WIDGET_VIEW_ITEM_GRID_ADD_WIDGET = 'WIDGET_VIEW_ITEM_GRID_ADD_WIDGET'
export const WIDGET_VIEW_ITEM_GRID_ITEM_SPLIT = 'WIDGET_VIEW_ITEM_GRID_ITEM_SPLIT'
export const WIDGET_VIEW_ITEM_GRID_ITEM_MERGE = 'WIDGET_VIEW_ITEM_GRID_ITEM_MERGE'
export const WIDGET_VIEW_ITEM_GRID_UPDATE_LAYOUTS = 'WIDGET_VIEW_ITEM_GRID_UPDATE_LAYOUTS'
export const WIDGET_SET_TARGET_RULES = 'WIDGET_SET_TARGET_RULES'

export const SET_DEFAULT_THEME = 'SET_DEFAULT_THEME'

export const PROJECT_LAST_ID = 'PROJECT_LAST_ID'
export const CLOSE_PERMISSION_ERROR = 'CLOSE_PERMISSION_ERROR'
export const SET_PERMISSION_ERROR = 'SET_PERMISSION_ERROR'

export const PB_REDO = 'PB_REDO'
export const PB_UNDO = 'PB_UNDO'

export const PROCESS_SF_GET = 'PROCESS_SF_GET'

export const FETCH_DATA_REQ = 'FETCH_DATA_REQ'
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR'

export const SET_WIDGETS_DATA = 'SET_WIDGETS_DATA'
export const SET_WIDGET_PREVIEW_DATA = 'SET_WIDGET_PREVIEW_DATA'
export const SET_WIDGET_PREVIEW_MAPPED_DATA = 'SET_WIDGET_PREVIEW_MAPPED_DATA'
export const SET_WIDGET_DATA = 'SET_WIDGET_DATA'
export const SET_WIDGET_STATIC_VAL = 'SET_WIDGET_STATIC_VAL'

export const LIST_WIDGET_CHANGE_FIELD = 'LIST_WIDGET_CHANGE_FIELD'

export const PROJECT_FORM_RESET = 'PROJECT_FORM_RESET'
export const FORM_CHANGE_FIELD = 'FORM_CHANGE_FIELD'
export const FORM_CHANGE_FILTER = 'FORM_CHANGE_FILTER'
export const PT_CHANGE_SELECTION = 'PT_CHANGE_SELECTION'
export const FORM_CLEAR_MESSAGES = 'FORM_CLEAR_MESSAGES'
export const PROCESS_COND_RULES = 'PROCESS_COND_RULES'
export const PROCESS_COND_RULES_BATCH = 'PROCESS_COND_RULES_BATCH'
export const PROCESS_META_ITEMS = 'PROCESS_META_ITEMS'
export const PROCESS_PAGE_ON_LOAD = 'PROCESS_PAGE_ON_LOAD'
export const COND_RULES_SET_STATUS = 'COND_RULES_SET_STATUS'
export const COND_RULES_SET_STATUS_BATCH = 'COND_RULES_SET_STATUS_BATCH'
export const COND_RULES_SET_STATUS_TO_FIELD = 'COND_RULES_SET_STATUS_TO_FIELD'
export const SET_IS_ALLOW_DEBUG_MODE = 'SET_IS_ALLOW_DEBUG_MODE'
export const PROCESS_AUTO_TRIGGER = 'PROCESS_AUTO_TRIGGER'
export const PROCESS_AUTO_START = 'PROCESS_AUTO_START'
export const PROCESS_AUTO_END = 'PROCESS_AUTO_END'

export const PROCESS_RESULT_AI = 'PROCESS_RESULT_AI'
export const PROCESS_SF_MAPPING = 'PROCESS_SF_MAPPING'
export const PROCESS_SF_SURVEY_MAPPING = 'PROCESS_SF_SURVEY_MAPPING'
export const PROCESS_VISIBILITY_SF_MAPPING = 'PROCESS_VISIBILITY_SF_MAPPING'
export const SF_MAPPING_ON_CHANGE_FIELD = 'SF_MAPPING_ON_CHANGE_FIELD'

export const SET_PAGE_LOADING_ELEMENTS = 'SET_PAGE_LOADING_ELEMENTS'

export const SHOW_LOADING_WINDOW = 'SHOW_LOADING_WINDOW'
export const CLOSE_LOADING_WINDOW = 'CLOSE_LOADING_WINDOW'

export const CALL_SF_ACTIONS = 'CALL_SF_ACTIONS'
export const SET_ELEM_RULE_STATUS = 'SET_ELEM_RULE_STATUS'

export const PROCESS_SHOW_MODAL = 'PROCESS_SHOW_MODAL'
export const REDIRECT_MODAL_CLOSE = 'REDIRECT_MODAL_CLOSE'
export const SET_ELEM_VALUE = 'SET_ELEM_VALUE'
export const SET_ELEM_VALUE_BATCH = 'SET_ELEM_VALUE_BATCH'
export const SET_STORE_PARAM = 'SET_STORE_PARAM'
export const SET_STORE_PARAMS = 'SET_STORE_PARAMS'
export const PROCESS_WB_BUTTON_ACTION = 'PROCESS_WB_BUTTON_ACTION'
export const PROCESS_WB_TABLE_ACTION = 'PROCESS_WB_TABLE_ACTION'
export const SET_WIDGET_PARAM = 'SET_WIDGET_PARAM'
export const OPEN_LOOKUP_MODAL = 'OPEN_LOOKUP_MODAL'
export const CLOSE_LOOKUP_MODAL = 'CLOSE_LOOKUP_MODAL'
export const PROCESS_SF_CHILD_MAPPING = 'PROCESS_SF_CHILD_MAPPING'
export const WIDGET_RELOAD_FINISH = 'WIDGET_RELOAD_FINISH'
export const PROCESS_SF_PUSH = 'PROCESS_SF_PUSH'

export const QUERY_ADD = 'QUERY_ADD'
export const QUERY_UNSHIFT = 'QUERY_UNSHIFT'
export const SHOW_DIALOG_MESSAGE = 'SHOW_DIALOG_MESSAGE'
export const CLOSE_DIALOG_MESSAGE = 'CLOSE_DIALOG_MESSAGE'

export const PORTAL_CHECK_SESS = 'PORTAL_CHECK_SESS'
export const PROCESS_WB_ELEM_DUP = 'PROCESS_WB_ELEM_DUP'
export const PROCESS_WB_ELEM_CUT = 'PROCESS_WB_ELEM_CUT'
export const PROCESS_WB_ELEM_COPY = 'PROCESS_WB_ELEM_COPY'
export const PROCESS_WB_ELEM_PASTE = 'PROCESS_WB_ELEM_PASTE'
export const PROCESS_WB_TEMPLATE_PASTE = 'PROCESS_WB_TEMPLATE_PASTE'

export const PROCESS_NEW_PROJECT = 'PROCESS_NEW_PROJECT'
export const PROCESS_OPEN_PROJECT = 'PROCESS_OPEN_PROJECT'

export const BUILDER_CLR_UI_STATE = 'BUILDER_CLR_UI_STATE'

export const SET_SHOW_ELEMENT_STYLE_PANEL = 'SET_SHOW_ELEMENT_STYLE_PANEL'
export const SET_SHOW_PROJECT_STYLE_PANEL = 'SET_SHOW_PROJECT_STYLE_PANEL'
export const SET_CLEAR_SELECTION = 'SET_CLEAR_SELECTION'
export const SET_ACTIVE_PROJECT_PANEL = 'SET_ACTIVE_PROJECT_PANEL'
export const SET_POSITION_PROJECT_PANEL = 'SET_POSITION_PROJECT_PANEL'

export const PROJECT_SET_UI_ADD_WIDGET = 'PROJECT_SET_UI_ADD_WIDGET'
export const PROJECT_CHANGE_UI_ADD_WIDGET = 'PROJECT_CHANGE_UI_ADD_WIDGET'
export const PROJECT_CHANGE_MODAL_STATE = 'PROJECT_CHANGE_MODAL_STATE'
export const PROJECT_BUILDER_CHANGE_ACTIVE_PAGE = 'PROJECT_BUILDER_CHANGE_ACTIVE_PAGE'
export const CHANGE_BACKDROP_STATUS = 'CHANGE_BACKDROP_STATUS'
export const REPOSITION_ELEMENTS_ON_DROP = 'REPOSITION_ELEMENTS_ON_DROP'
export const PROJECT_COPY_STL_FOR_MODE = 'PROJECT_COPY_STL_FOR_MODE'

export const RESET_PRINT_FLAG = 'RESET_PRINT_FLAG'
export const CLEAR_RECENT_UPDATES = 'CLEAR_RECENT_UPDATES'
export const PROCESS_PARAMS_UPDATED = 'PROCESS_PARAMS_UPDATED'
export const PROJECT_CLEAR_POST_MSG_TASK = 'PROJECT_CLEAR_POST_MSG_TASK'
export const PROJECT_PREVIEW_SET_ON_LOAD_DATA = 'PROJECT_PREVIEW_SET_ON_LOAD_DATA'
export const UPDATE_PUBLISHED_TIME = 'UPDATE_PUBLISHED_TIME'
export const HIDE_SF_NOTIFY_MESSAGES = 'HIDE_SF_NOTIFY_MESSAGES'
export const SHOW_SF_NOTIFY_MESSAGES = 'SHOW_SF_NOTIFY_MESSAGES'
export const SHOW_PAYMENT_MODAL = 'SHOW_PAYMENT_MODAL'
export const PROJECT_FINISH_ANIMATION = 'PROJECT_FINISH_ANIMATION'
export const PROJECT_UPDATE_FORM_COL = 'PROJECT_UPDATE_FORM_COL'
export const PROJECT_FORM_DROP_ELEM = 'PROJECT_FORM_DROP_ELEM'
export const PROJECT_FORM_MOVE_ELEM = 'PROJECT_FORM_MOVE_ELEM'
export const PROJECT_PAGE_BREAK_CHANGE = 'PROJECT_PAGE_BREAK_CHANGE'
export const PROJECT_FORM_DEL_ITEM = 'PROJECT_FORM_DEL_ITEM'
export const PROJECT_FORM_ADD_ITEM = 'PROJECT_FORM_ADD_ITEM'
export const SET_STORE = 'SET_STORE'
export const CHANGE_SYNC_STATUS = 'CHANGE_SYNC_STATUS'

export const PROCESS_SF_CHAT_BOT_MAPPING = 'PROCESS_SF_CHAT_BOT_MAPPING'
export const START_KANBAN_FIELDS_UPDATE = 'START_KANBAN_FIELDS_UPDATE'
export const APPLY_KANBAN_FIELDS_UPDATE = 'APPLY_KANBAN_FIELDS_UPDATE'
export const FILES_LIMIT_REACHED = 'FILES_LIMIT_REACHED'
